{
	"title": "Fleet",
	"common": {
		"active": "Active",
		"inactive": "Inactive",
		"loading": "Loading…",
		"retry": "Try again",
		"clearFilters": "Clear filters"
	},
	"vehicleType": {
		"CAR": "Private car",
		"VAN": "Van",
		"BUS": "Bus"
	},
	"vehicleTypePlural": {
		"CAR": "Private cars",
		"VAN": "Vans",
		"BUS": "Buses"
	},
	"vehicleStatus": {
		"ACTIVE": "Active",
		"MAINTENANCE": "Maintenance",
		"RETIRED": "Retired"
	},
	"vehicleStatusHint": {
		"ACTIVE": "Offered for trips",
		"MAINTENANCE": "Not offered for trips until it is back",
		"RETIRED": "Out of the fleet for good; its past trips stay on record"
	},
	"driverNow": {
		"ON_TRIP": "On trip",
		"ON_DUTY": "On duty",
		"OFF_DUTY": "Off duty",
		"REST": "Rest day"
	},
	"placeKind": {
		"VENUE": "Venues",
		"PLACE": "Places",
		"ENTRY_POINT": "Entry points"
	},
	"vehicle": {
		"ramp": "Ramp"
	},
	"shift": {
		"range": "{{from}}–{{to}}",
		"overnight": "overnight",
		"noRest": "No fixed rest day",
		"noRestShort": "None"
	},
	"cluster": {
		"choose": "Choose a cluster"
	},
	"clusterField": {
		"label": "Transport cluster",
		"column": "Cluster",
		"none": "Not set",
		"venueHint": "Drive times and transport dispatch use it. A venue without a cluster is not offered for trips.",
		"entryPointHint": "Drive times from here to hotels and venues use it. Without one, a transfer takes the cluster of its other end.",
		"invalid": "Pick a cluster from the list"
	},
	"fleet": {
		"tabs": {
			"label": "Show",
			"drivers": "Drivers",
			"vehicles": "Vehicles",
			"providers": "Companies"
		},
		"setup": {
			"clusters": "Clusters & drive times",
			"places": "Places",
			"dropoffs": "Drop-offs",
			"settings": "Settings"
		},
		"addDriver": "Add driver",
		"addVehicle": "Add vehicle",
		"addProvider": "Add company",
		"clusterChips": "Cluster",
		"readOnly": "Your company's vehicles and drivers. The transport desk keeps this list up to date."
	},
	"drivers": {
		"searchPlaceholder": "Driver Name or Phone",
		"statusChips": "Status now",
		"sort": {
			"name": "Name A–Z",
			"cluster": "Cluster"
		},
		"summary_one": "{{from}}–{{to}} of {{total}} driver",
		"summary_other": "{{from}}–{{to}} of {{total}} drivers",
		"summaryEmpty": "No drivers",
		"table": {
			"driver": "Driver",
			"phone": "Phone",
			"certified": "Certified",
			"vehicles": "Vehicles",
			"cluster": "Cluster",
			"shift": "Shift",
			"restDay": "Rest day",
			"statusNow": "Status now",
			"tripsToday": "Trips today",
			"schedule": "{{n}} · schedule",
			"viewSchedule": "Open {{name}}'s schedule",
			"edit": "Edit {{name}}"
		},
		"empty": {
			"filteredTitle": "No drivers match",
			"filteredDescription": "Try another status or cluster.",
			"noneTitle": "No drivers yet",
			"noneDescription": "Add the drivers who take trips, with their shift and the vehicles they usually drive.",
			"noneReadOnly": "The transport desk has not added your company's drivers yet."
		}
	},
	"vehicles": {
		"searchPlaceholder": "Plate, Model or Remarks",
		"typeChips": "Vehicle type",
		"statusChips": "Status",
		"sort": {
			"type": "Type",
			"plate": "Plate",
			"seats": "Most seats"
		},
		"summary_one": "{{from}}–{{to}} of {{total}} vehicle",
		"summary_other": "{{from}}–{{to}} of {{total}} vehicles",
		"summaryEmpty": "No vehicles",
		"table": {
			"type": "Type",
			"plate": "Plate",
			"model": "Model",
			"cluster": "Cluster",
			"seats": "Seats",
			"remarks": "Remarks",
			"status": "Status",
			"tripsToday": "Trips today",
			"edit": "Edit {{plate}}"
		},
		"empty": {
			"filteredTitle": "No vehicles match",
			"filteredDescription": "Try another type or cluster.",
			"noneTitle": "No vehicles yet",
			"noneDescription": "Add the cars, vans and buses the Games can use, each in its cluster.",
			"noneReadOnly": "The transport desk has not added your company's vehicles yet."
		}
	},
	"providers": {
		"intro": "The transport companies that run vehicles for the Games. A company's own logins see its vehicles, drivers and the trips on them; give them a Transport provider user group that names the company.",
		"searchPlaceholder": "Company Name",
		"summary_one": "{{from}}–{{to}} of {{total}} company",
		"summary_other": "{{from}}–{{to}} of {{total}} companies",
		"summaryEmpty": "No companies",
		"table": {
			"company": "Company",
			"contact": "Contact",
			"vehicles": "Vehicles",
			"drivers": "Drivers",
			"groups": "Login groups",
			"status": "Status",
			"edit": "Edit {{name}}"
		},
		"empty": {
			"filteredTitle": "No companies match",
			"filteredDescription": "Try another name.",
			"noneTitle": "No transport companies yet",
			"noneDescription": "Add the companies that provide vehicles and drivers, then give them their own logins."
		}
	},
	"vehicleForm": {
		"addTitle": "Add vehicle",
		"addDescription": "Complete the vehicle information",
		"editTitle": "Edit vehicle",
		"type": "Vehicle type",
		"plate": "Plate number",
		"platePlaceholder": "WXY 1234",
		"model": "Model",
		"modelPlaceholder": "Toyota Hiace",
		"cluster": "Cluster",
		"clusterHint": "It takes trips in this cluster.",
		"seats": "Passenger seats",
		"seatsHint": "{{type}}: {{min}} to {{max}}",
		"status": "Status",
		"upcoming_one": "{{n}} upcoming trip",
		"upcoming_other": "{{n}} upcoming trips",
		"noUpcoming": "No upcoming trips",
		"company": "Company",
		"companyHint": "Its company's logins can see it and its trips.",
		"companyNone": "The host's own",
		"ramp": "Wheelchair ramp or lift",
		"remarks": "Remarks",
		"remarksPlaceholder": "Large luggage hold, VIP car…",
		"save": "Save vehicle",
		"toast": {
			"added": "Vehicle added · {{plate}}",
			"updated": "Saved · {{plate}}",
			"addFailed": "Couldn't add the vehicle",
			"updateFailed": "Couldn't save the vehicle"
		}
	},
	"driverForm": {
		"addTitle": "Add driver",
		"addDescription": "Complete the driver information",
		"editTitle": "Edit driver",
		"name": "Driver name",
		"phone": "Phone number",
		"dial": "Calling code",
		"cluster": "Cluster",
		"clusterHint": "Drivers take trips in their own cluster.",
		"company": "Company",
		"certified": "Certified for",
		"vehicles": "Usual vehicles",
		"vehiclesHint": "A vehicle can be linked to more than one driver. Each trip still checks that nobody is double-booked.",
		"vehiclesNeedCluster": "Choose a cluster first. Only its vehicles can be linked.",
		"vehiclesNeedType": "Tick at least one vehicle type above.",
		"noneInCluster": "None in this cluster",
		"vehicleLine": "{{model}} · {{seats}}",
		"vehiclesCleared": "Linked vehicles were cleared. They belong to the old cluster.",
		"shiftStart": "Shift starts",
		"shiftEnd": "Shift ends",
		"shiftHint": "An end before the start means an overnight shift.",
		"restDay": "Rest day",
		"active": "Active",
		"activeHint": "An inactive driver is not offered for trips.",
		"save": "Save driver",
		"toast": {
			"added": "Driver added · {{name}}",
			"updated": "Saved · {{name}}",
			"addFailed": "Couldn't add the driver",
			"updateFailed": "Couldn't save the driver"
		}
	},
	"providerForm": {
		"addTitle": "Add transport company",
		"addDescription": "The company and the person the transport desk calls",
		"name": "Company name",
		"contactName": "Contact person",
		"phone": "Contact phone",
		"email": "Email",
		"active": "In service",
		"activeHint": "A company out of service is not offered in the vehicle and driver sheets.",
		"save": "Save company",
		"toast": {
			"added": "Company added · {{name}}",
			"updated": "Saved · {{name}}",
			"addFailed": "Couldn't add the company",
			"updateFailed": "Couldn't save the company"
		}
	},
	"clusters": {
		"title": "Clusters & drive times",
		"description": "Shared by transport, accommodation and dining",
		"panel": {
			"clusters": "Clusters",
			"drive": "Drive times"
		},
		"none": "No clusters yet. Add the first one below.",
		"usage": {
			"vehicles_one": "{{n}} vehicle",
			"vehicles_other": "{{n}} vehicles",
			"drivers_one": "{{n}} driver",
			"drivers_other": "{{n}} drivers",
			"venues_one": "{{n}} venue",
			"venues_other": "{{n}} venues",
			"entryPoints_one": "{{n}} entry point",
			"entryPoints_other": "{{n}} entry points",
			"places_one": "{{n}} place",
			"places_other": "{{n}} places",
			"none": "Not used yet"
		},
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}",
		"deleteInUse": "{{name}} is in use. Move what uses it to another cluster first.",
		"confirmDelete": "Delete this cluster?",
		"delete": "Delete",
		"keep": "Keep",
		"inUse": "Still in use. Move its vehicles, drivers, venues, entry points and places to another cluster first.",
		"addTitle": "Add a cluster",
		"editTitle": "Edit {{name}}",
		"code": "Code",
		"codeHint": "2 to 8 capital letters or digits",
		"name": "Name",
		"order": "Order",
		"remarks": "Remarks",
		"remarksPlaceholder": "Venues in this cluster",
		"add": "Add cluster",
		"save": "Save cluster",
		"cancelEdit": "Cancel edit",
		"toast": {
			"added": "Cluster added · {{name}}",
			"updated": "Cluster saved · {{name}}",
			"deleted": "Cluster deleted · {{name}}",
			"addFailed": "Couldn't add the cluster",
			"updateFailed": "Couldn't save the cluster",
			"deleteFailed": "Couldn't delete the cluster"
		}
	},
	"drive": {
		"intro": "Minutes on the road from one cluster to another. They time every transfer and how long a vehicle is tied up. An empty cell uses the default, {{n}} min.",
		"mirror": "Same time both ways",
		"caption": "Drive minutes: rows are where a trip starts, columns where it ends",
		"fromTo": "From ↓ · To →",
		"cellLabel": "Minutes from {{from}} to {{to}}",
		"sameCluster": "A trip inside this cluster",
		"legend": "An empty cell uses the default ({{n}} min). The dashed diagonal is a trip inside one cluster. Darker cells are longer drives.",
		"badCells": "Enter whole minutes, {{min}} to {{max}}, or leave the cell empty.",
		"noClusters": "Add a cluster first to set drive times.",
		"save": "Save drive times",
		"saved": "Drive times saved",
		"saveFailed": "Couldn't save the drive times"
	},
	"places": {
		"title": "Places",
		"description": "Hotels, embassies and training grounds that trips start or end at. Venues and entry points are places already.",
		"none": "No places yet. Add the first one below.",
		"trips_one": "{{n}} trip starts or ends here",
		"trips_other": "{{n}} trips start or end here",
		"noTrips": "No trips yet",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}",
		"deleteInUse": "{{name}} has trips. Switch it off instead.",
		"confirmDelete": "Delete this place?",
		"delete": "Delete",
		"keep": "Keep",
		"inUse": "Trips start or end here. Switch it off instead.",
		"addTitle": "Add a place",
		"editTitle": "Edit {{name}}",
		"name": "Name",
		"namePlaceholder": "Hotel Istana",
		"cluster": "Cluster",
		"address": "Address",
		"hotel": "Hotel",
		"hotelNone": "Not a hotel",
		"hotelHint": "Travellers with a room in this hotel are driven to and from this place.",
		"hotelLinked": "Hotel: {{name}}",
		"hotelTakenBy": "Already linked to {{place}}",
		"active": "Offered for trips",
		"activeHint": "Switch off a place that is no longer used. Its past trips keep it.",
		"add": "Add place",
		"save": "Save place",
		"cancelEdit": "Cancel edit",
		"toast": {
			"added": "Place added · {{name}}",
			"updated": "Place saved · {{name}}",
			"deleted": "Place deleted · {{name}}",
			"addFailed": "Couldn't add the place",
			"updateFailed": "Couldn't save the place",
			"deleteFailed": "Couldn't delete the place"
		}
	},
	"dropoffs": {
		"title": "Contingent drop-offs",
		"description": "Where each contingent's arrivals go until rooms are assigned. Suggested transfers take it as their destination, and a contingent's trip requests start there.",
		"none": "No drop-off",
		"pickFor": "Drop-off for {{name}}",
		"noPlaces": "No place has a cluster yet. Give venues a cluster, or add places, first.",
		"count_one": "{{count}} of {{total}} has a drop-off",
		"count_other": "{{count}} of {{total}} have a drop-off",
		"save": "Save drop-offs",
		"saved_one": "Saved {{count}} drop-off",
		"saved_other": "Saved {{count}} drop-offs",
		"saveFailed": "Couldn't save the drop-offs"
	},
	"settings": {
		"title": "Transport settings",
		"description": "For this Games. Changes apply to trips timed from now on.",
		"field": {
			"default_drive_minutes": "Default drive time",
			"noc_lead_hours": "Contingent booking lead",
			"adhoc_buffer_minutes": "Venue trip buffer",
			"group_spread_minutes": "Transfer spread"
		},
		"hint": {
			"default_drive_minutes": "Used between clusters with no drive time set. Default {{n}}.",
			"noc_lead_hours": "Contingents book venue trips at least this far ahead. The host is not bound. Default {{n}}.",
			"adhoc_buffer_minutes": "A one-way venue trip holds its vehicle for the drive plus this. Default {{n}}.",
			"group_spread_minutes": "A delayed passenger further than this from the rest of the transfer leaves it. Default {{n}}."
		},
		"minutes": "min",
		"hours": "h",
		"updated": "Last changed {{stamp}}",
		"save": "Save settings",
		"saved": "Transport settings saved",
		"saveFailed": "Couldn't save the transport settings"
	},
	"week": {
		"title": "Driver",
		"subtitle": "Driver schedule",
		"back": "Back to drivers",
		"loadFailed": "Couldn't load this driver",
		"edit": "Edit",
		"noUsualVehicles": "No usual vehicles",
		"strip": {
			"label": "Driver summary",
			"cluster": "Cluster",
			"certified": "Certified for",
			"shift": "Shift",
			"restDay": "Rest day",
			"trips": "Trips this week"
		},
		"assigned": "Assigned trips",
		"range": "{{from}} – {{to}}. Weeks start on Monday. Times in {{zone}}.",
		"thisWeek": "This week",
		"previous": "Previous week",
		"next": "Next week",
		"today": "today",
		"restDay": "Rest day",
		"trips_one": "{{n}} trip",
		"trips_other": "{{n}} trips",
		"restNotAssignable": "Rest day. Not assignable.",
		"noTrips": "No trips assigned",
		"route": "{{from}} → {{to}}",
		"pax_one": "{{n}} pax",
		"pax_other": "{{n}} pax",
		"truncated": "Showing the first 500 trips of this week."
	},
	"trips": {
		"route": "{{from}} → {{to}}",
		"tabsLabel": "Trips",
		"tab": {
			"upcoming": "Upcoming",
			"past": "Past"
		},
		"statusChips": "Status",
		"passengers_one": "{{n}} passenger",
		"passengers_other": "{{n}} passengers",
		"wheelchairTitle": "Wheelchair users",
		"bagsTitle": "Bags and equipment cases",
		"return": "return {{time}}",
		"reason": "Reason: {{reason}}",
		"loadFailed": "Couldn't load the trips",
		"showing_one": "Showing {{from}} to {{to}} of {{total}} trip",
		"showing_other": "Showing {{from}} to {{to}} of {{total}} trips",
		"showingNoTotal": "Showing {{from}} to {{to}}",
		"showingEmpty": "No trips",
		"previousDay": "Previous day",
		"nextDay": "Next day",
		"pickDay": "Pick a day",
		"today": "Today",
		"backToToday": "Back to today"
	},
	"noc": {
		"strip": {
			"upcomingLabel": "Your upcoming trips",
			"upcoming": "Upcoming trips",
			"upcomingNote": "As in the list below",
			"waiting": "Waiting for a driver",
			"hostAssigns": "The host assigns",
			"assigned": "Driver assigned",
			"onTheRoad": "On the road",
			"doneToday": "Done today"
		},
		"title": "Your trips",
		"count_one": "{{n}} trip",
		"count_other": "{{n}} trips",
		"intro": "Airport transfers are arranged by the host from your records' arrival and departure details. Times in {{zone}}.",
		"request": "Request a trip",
		"waitingForHost": "Waiting for the host to assign a vehicle",
		"transferNote": "Follows your travel. Change the travel to change the trip.",
		"cancel": "Cancel",
		"cancelTitle": "Cancel this trip",
		"cancelDescription": "{{ref}} · The driver is released.",
		"reason": "Reason",
		"reasonPlaceholder": "The transport desk sees this",
		"back": "Back",
		"cancelConfirm": "Cancel trip",
		"cancelled": "Trip cancelled · {{ref}}",
		"cancelFailed": "Couldn't cancel the trip",
		"cancelSkipped": {
			"not_in_scope": "This trip is not yours to cancel.",
			"not_open": "This trip is already closed.",
			"in_progress": "A vehicle has already left. Call the transport desk."
		},
		"empty": {
			"noneTitle": "No trips yet",
			"noneDescription": "Request a bus to training or competition. The host assigns a vehicle and driver.",
			"pastTitle": "No past trips",
			"pastDescription": "Trips you have taken show here.",
			"filteredTitle": "No trips with this status",
			"filteredDescription": "Pick another status."
		}
	},
	"provider": {
		"company": "Company: {{name}}",
		"zoneNote": "Times in {{zone}}",
		"strip": {
			"label": "The day on your vehicles",
			"trips": "Trips",
			"waiting": "Waiting to start",
			"onTheRoad": "On the road",
			"drivers_one": "{{n}} driver driving",
			"drivers_other": "{{n}} drivers driving",
			"arrived": "Arrived",
			"onDuty": "Drivers on duty",
			"ofDrivers": "of {{n}}"
		},
		"emptyTitle": "No trips on your vehicles this day",
		"emptyDescription": "The transport desk assigns your vehicles to trips. Pick another day to look ahead.",
		"hostGroup": "Host",
		"lead": "lead {{name}}",
		"pax_one": "{{n}} assigned · {{seats}} seats",
		"pax_other": "{{n}} assigned · {{seats}} seats",
		"fewerNow_one": "{{n}} passenger now — the desk will adjust",
		"fewerNow_other": "{{n}} passengers now — the desk will adjust",
		"start": "Start trip",
		"arrive": "Arrived",
		"started": "On the road · {{plate}}",
		"arrived": "Arrived · {{plate}}",
		"startFailed": "Couldn't start the trip",
		"arriveFailed": "Couldn't mark the trip arrived"
	},
	"request": {
		"title": "Request a trip",
		"description": "For training or competition. The host assigns a vehicle and driver.",
		"org": "For",
		"orgPlaceholder": "Choose the contingent",
		"hostTrip": "The host's own trip",
		"date": "Date",
		"time": "Pick-up time ({{zone}})",
		"timeHint": "On the {{zone}} clock.",
		"leadHint_one": "Request at least {{n}} hour ahead.",
		"leadHint_other": "Request at least {{n}} hours ahead.",
		"from": "Pick up at",
		"to": "Go to",
		"choose": "Choose",
		"group": {
			"dropoff": "Your drop-off",
			"places": "Places",
			"venues": "Venues",
			"entryPoints": "Entry points"
		},
		"count": "Passengers",
		"countWithNamed_one": "Plus {{n}} named passenger",
		"countWithNamed_other": "Plus {{n}} named passengers",
		"wheelchair": "Of whom wheelchair users",
		"addNamed": "Name the passengers (optional)",
		"namedTitle": "Named passengers",
		"namedSearch": "Name or Card Number",
		"namedFind": "Search",
		"namedNone": "No approved record matches.",
		"namedFailed": "Couldn't search the records.",
		"namedRemove": "Remove {{name}}",
		"return": "Return pick-up time ({{zone}})",
		"returnHint": "Leave empty for one way. A time before the pick-up is the next morning.",
		"contactName": "Contact on the day",
		"contactHint": "The driver and the transport company call this person.",
		"contactPhone": "Contact phone",
		"remarks": "Remarks",
		"remarksPlaceholder": "Meet at the lobby. Equipment bags.",
		"send": "Send request",
		"sent": "Sent to the transport desk · {{ref}}",
		"failed": "Couldn't send the request",
		"deskTitle": "New trip",
		"deskDescription": "A venue trip, or an arrival or departure transfer. The people you name on a transfer ride with their own flight.",
		"create": "Create trip",
		"created": "{{ref}} created",
		"createdTransfer": "{{ref}} created · {{linked}}",
		"legsLinked_one": "{{n}} person's travel linked",
		"legsLinked_other": "{{n}} people's travel linked",
		"alreadyOnTransfer_one": "{{n}} person already rides on {{refs}}: they were added without their travel.",
		"alreadyOnTransfer_other": "{{n}} people already ride on {{refs}}: they were added without their travel.",
		"kind": {
			"label": "Kind of trip",
			"ADHOC": "Venue trip",
			"ARR": "Arrival transfer",
			"DEP": "Departure transfer",
			"arrHint": "From an entry point. Name the people: each one's arrival is linked, so they leave Suggested transfers.",
			"depHint": "To an entry point. Name the people: each one's departure is linked, so they leave Suggested transfers."
		}
	},
	"validation": {
		"invalidValue": "Check this value",
		"tooLong": "At most {{max}} characters",
		"vehicleTypeRequired": "Choose a vehicle type",
		"plateRequired": "Plate number is required",
		"plateInvalid": "Use letters, digits, spaces or dashes, like WXY 1234",
		"plateTaken": "Another vehicle has this plate number",
		"modelRequired": "Vehicle model is required",
		"clusterRequired": "Choose a cluster",
		"seatsRange": {
			"CAR": "A private car seats {{min}} to {{max}} passengers",
			"VAN": "A van seats {{min}} to {{max}} passengers",
			"BUS": "A bus seats {{min}} to {{max}} passengers"
		},
		"upcomingTrips_one": "Has {{count}} upcoming trip ({{refs}}). Reassign it first",
		"upcomingTrips_other": "Has {{count}} upcoming trips ({{refs}}). Reassign them first",
		"driverNameRequired": "Driver name is required",
		"dialRequired": "Choose the calling code",
		"phoneDigits": "Phone number must be {{min}} to {{max}} digits",
		"phoneInvalid": "Enter a valid phone number",
		"typesRequired": "Choose at least one vehicle type",
		"vehicleNotCertified": "Each usual vehicle must be of a type the driver is certified for",
		"timeRequired": "Enter a time",
		"shiftSame": "Set a shift with different start and end times",
		"companyNameRequired": "Company name is required",
		"companyNameTaken": "Another company has this name",
		"emailInvalid": "Enter a valid email address",
		"clusterCode": "Use 2 to 8 capital letters or digits",
		"clusterCodeTaken": "Another cluster has this code",
		"clusterNameRequired": "Cluster name is required",
		"clusterNameTaken": "A cluster with this name already exists",
		"placeNameRequired": "Place name is required",
		"placeNameTaken": "Another place has this name",
		"hotelTaken": "Another place is already linked to this hotel",
		"settingRange": "Enter a whole number, {{min}} to {{max}}",
		"orgRequired": "Choose the contingent",
		"dateRequired": "Choose a date",
		"pickupPassed": "The pick-up time has passed",
		"leadTime": "Request at least {{hours}} hours ahead. The earliest you can book is {{when}}",
		"placeRequired": "Choose a place",
		"countInvalid": "Enter a whole number, 0 or more",
		"passengersRequired": "Add at least one passenger",
		"wheelchairTooMany": "More wheelchair users than passengers"
	},
	"formMessages": {
		"required": "Required",
		"textTooLong": "Too long",
		"dateInvalid": "Enter a valid date",
		"nameRequired": "Enter a name",
		"nothingToChange": "Nothing to change",
		"idsDuplicate": "Listed twice",
		"codeInvalid": "Use 2 to 8 capital letters or digits",
		"plateInvalid": "Enter a plate number like WXY 1234",
		"seatsInvalid": "Seats do not fit this vehicle type",
		"phoneInvalid": "Enter the phone number with its country code, like +60123456789",
		"emailInvalid": "Enter a valid email address",
		"vehicleTypesRequired": "Choose at least one vehicle type",
		"timeInvalid": "Enter a time like 07:00",
		"shiftEmpty": "Set a shift with different start and end times",
		"restDayInvalid": "Pick a day of the week",
		"minutesInvalid": "Enter whole minutes, {{min}} to {{max}}",
		"numberInvalid": "Enter a whole number in range",
		"sortOrderInvalid": "Enter a whole number, 0 or more",
		"rowsMax": "Too many rows",
		"pairInvalid": "Each pair of clusters once"
	},
	"tripMessages": {
		"required": "Required",
		"textTooLong": "Too long",
		"dateInvalid": "Enter a valid date",
		"dateTimeInvalid": "Enter a valid date and time",
		"rangeInvalid": "The end date must be on or after the start date",
		"rangeTooLong_one": "At most {{count}} day",
		"rangeTooLong_other": "At most {{count}} days",
		"idsDuplicate": "Listed twice",
		"nothingToChange": "Nothing to change",
		"samePlace": "Pick-up and drop-off are the same place",
		"entryPointEnd": "An arrival starts at an entry point; a departure ends at one",
		"returnInvalid": "The return pick-up must be after the pick-up",
		"timeConflict": "Either fix the pick-up time or follow the flight, not both",
		"passengersRequired": "Add at least one passenger",
		"passengersMax": "At most {{max}} named passengers",
		"countInvalid": "Enter a whole number, 0 or more",
		"wheelchairTooMany": "More wheelchair users than passengers",
		"minutesInvalid": "Enter whole minutes, {{min}} to {{max}}",
		"rowsMax": "At most {{max}} vehicles",
		"reasonRequired": "Give a reason"
	},
	"groupFacility": {
		"dispatchMissing": "Its logins can see their trips but cannot press Start or Arrived. That needs “{{permission}}” in this group's permissions.",
		"grant": "Allow Start / Arrived",
		"granted": "Start / Arrived allowed for this group",
		"grantFailed": "Couldn't allow Start / Arrived"
	}
}
